import { useForm } from "@mantine/form";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import Form from "./resetform";
import { isPassword, validatePassword, validateConfirmPassword } from "../../helpers/common";
import { userResetPassword } from "../../store/actions";

const ResetPassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const userName = searchParams.get("CusId") || "";
  const form = useForm({
    initialValues: {
      userName,
      password: "",
      confirmPassword: "",
    },
    validate: {
      password: (value) => validatePassword(value, "New Password"),
      confirmPassword: (value, values) => validateConfirmPassword(value, values.password),
    },
  });

  const submit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const validationResult = form.validate();

    if (!validationResult.hasErrors) {
      const { confirmPassword, ...data } = form.values;
      dispatch(userResetPassword(data,navigate));
     
    }
  };

  return <Form formData={form} submit={submit} />;
};

export default ResetPassword;
